import React from 'react';

import { Countries } from '../../constants/countries';
import { useTranslation } from 'react-i18next';
import * as i18next from 'i18next';
import { useCountriesList } from '../../hooks/queryHooks';
import SingleSelect from '../../components/forms/SingleSelect';
import { useBankSearchState } from '../../hooks/zustandHooks';
import FeatherIcon from 'feather-icons-react';

const convertCountriesToSelectOptions = (countries: string[], t: i18next.TFunction) => {
  const options = [];

  for (const countryCode of countries) {
    const name: string = Countries[countryCode as keyof typeof Countries];

    if (!name) {
      continue;
    }

    options.push({
      value: countryCode,
      label: `${t(name)} (${countryCode})`
    });
  }

  options.sort((a, b) => (a.label > b.label ? 1 : -1));

  return options;
};

const CountryDropdown: React.FC = () => {
  const { t } = useTranslation();
  const { selectedCountry, setSelectedCountry } = useBankSearchState();
  const { countriesList } = useCountriesList();

  const selectedValue = selectedCountry || countriesList?.countryCodes?.find(x => x !== undefined);
  const options = convertCountriesToSelectOptions(countriesList?.countryCodes || [], t);
  if (options.length < 2) {
    return null;
  }

  return (
    <div className="relative mr-2" data-testid="country-dropdown">
      <div aria-hidden="true" className="pointer-events-none">
        <FeatherIcon icon="chevron-down" className="absolute right-4 top-3 text-gray-600" />
      </div>
      <SingleSelect
        label={t('Select country')}
        className={`h-[56px] px-4`}
        customLabel={true}
        options={options}
        value={selectedValue}
        onChangeValue={e => setSelectedCountry(e.currentTarget.value)}
      />
    </div>
  );
};

export default CountryDropdown;
